import Vue from 'vue'
import Router from 'vue-router'
import Breaking from '../views/Breaking.vue'
import Index from '../views/Index.vue'
import Nieuws from '../views/Nieuws.vue'
import Privacy from '../views/Privacy.vue'
import Overons from '../views/Overons.vue'
import Artikel from '../views/Artikel.vue'

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            title: 'Twiedalia nieuws',
            component: Index
        },
        {
            path: '/nieuws',
            name: 'Nieuws',
            component: Nieuws
        },
        {
            path: '/tussenstand',
            name: 'brekendnieuws',
            component: Breaking
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: Privacy
        },
        {
            path: '/overons',
            name: 'overons',
            component: Overons
        },
        {
            path: '/artikel/:id',
            name: 'artikel',
            component: Artikel
        }
    ]
})
